module.exports = __webpack_public_path__ + "img/pinVerde.6717c697.png";